export function elementOrParentMatchesSelector(el: HTMLElement, selector: string): boolean {
  let target: HTMLElement | null = el
  while (target) {
    if (target.matches(selector)) return true
    target = target.parentElement
  }
  return false
}
